import { render, staticRenderFns } from "./BillingPendency.vue?vue&type=template&id=330434a9"
import script from "./BillingPendency.vue?vue&type=script&lang=ts"
export * from "./BillingPendency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports